import { defineStore } from "pinia";
import _rest from "../plugins/rest";

export const usePaymentsStore = defineStore("payments", {
    state: () => ({
        methods: {},
    }),
    getters: {
        paymentMethodName: (state) => (id) => state.methods[id],
    },
    actions: {
        async initPayments() {
            const methods = await _rest.get("/payments/backends/available", undefined, {
                overlay: false,
            });

            this.methods = {};
            for (const method of methods) {
                this.methods[method.id] = method.name;
            }
        },
    },
});
